<template>
  <div class="workpackage-large-header">
    <v-card
      v-for="wp in work_packages"
      :key="wp.id" class="tab mb-5"
      :style="getTabStyle(wp)"
      :color="`${wp.color} ${wp.color.includes('lighten') || wp.color.includes('darken')? '':'lighten-1'}`"
      @click="$emit('selectWP', wp.id)">
        <svg-icon class="pull-left ml-1" :name="`${wp.icon}`" :size="30"></svg-icon>
        <span v-if="selected_id === wp.id">
          <v-row class="my-row ma-0 pa-0">
            <v-col>
              <b class="pull-left" :style="`color: ${wp.textcolor}; text-justify: center`">
                {{wp.token}}
                <slot name="name" />
              </b>
            </v-col>
          </v-row>
          <v-row class="my-row ma-0 pa-0">
            <v-col>
              <slot name="status"/>
            </v-col>
          </v-row>
        </span>
    </v-card>
    <v-divider align-center class="ma-0" inset color="black"></v-divider>
  </div>
</template>
<script>
export default {
  name: 'WorkPackageLargeHead',
  props: ['work_packages', 'selected_id'],
  methods: {
    getTabStyle(wp){
      let style = '';
      let tab_width = '';
      if (this.selected_id === wp.id) {
        tab_width = `calc(100% - ${(this.work_packages.length - 1)}*50px);`;
        style += 'z-index: 2;';
      } else {
        tab_width = '50px;';
        style += 'padding-top: 15px;padding-left: 5px;';
      }
      style += `border-radius: 0px 0px 0px 0px; width: ${tab_width};`;
      return style;
    }
  }
}
</script>
<style lang="css" scoped>
.workpackage-large-header{
  margin-top: -30px;
  margin-left: -10px;
  margin-right: -10px;
}
.tab {
  position: relative;
  top: 0.5vw;
  left: 0;
  height: 65px;
  padding-top: 5px;
  float: left;
  overflow-y: hidden !important;
  /* text-overflow: hidden; */
  white-space: nowrap;
  font-size: 25px;
}
.my-row {
  margin-top: -15px !important;
}
</style>
